import { Field, Area } from "./fields";

export const PerfilTab = ({ draft, setDraft }) => (
  <div className="space-y-5">
    <div className="grid sm:grid-cols-2 gap-4">
      <Field label="Nombre" testId="perfil-nombre" value={draft.hero.name}
        onChange={(v) => setDraft({ ...draft, hero: { ...draft.hero, name: v } })} />
      <Field label="Nombre artístico" testId="perfil-artistico" value={draft.hero.stageName}
        onChange={(v) => setDraft({ ...draft, hero: { ...draft.hero, stageName: v } })} />
    </div>
    <Field label="Descripción (ej. Actor, locutor y empresario)" testId="perfil-descripcion" value={draft.hero.description}
      onChange={(v) => setDraft({ ...draft, hero: { ...draft.hero, description: v } })} />
    <Field label="Frase de portada" testId="perfil-tagline" value={draft.hero.tagline}
      onChange={(v) => setDraft({ ...draft, hero: { ...draft.hero, tagline: v } })} />
    <Field label="Título de Mi Historia" testId="perfil-historia-titulo" value={draft.historiaHeading}
      onChange={(v) => setDraft({ ...draft, historiaHeading: v })} />
    <Area label="Biografía (separa los párrafos con una línea en blanco)" testId="perfil-biografia" rows={14}
      value={(draft.biography || []).join("\n\n")}
      onChange={(v) => setDraft({ ...draft, biography: v.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean) })} />
  </div>
);
